import numeral from 'numeral';
import 'numeral/locales/de';

numeral.localeData('de').delimiters.thousands = '.';
numeral.localeData('de').delimiters.decimal = ',';

export default numeral;
